import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';

export default function addJeepytaPageButton() {
  extend(UserPage.prototype, 'navItems', function (items) {
    const canUpload = !!app.forum.attribute('fof-upload.canUpload');
    const hasUploads = !!this.user.uploadCountCurrent();

    if (app.session.user && (app.session.user.viewOthersMediaLibrary() || (this.user === app.session.user && (canUpload || hasUploads)))) {
      const uploadCount = this.user.uploadCountCurrent();
      if (this.user === app.session.user) {
        items.add(
          'uploads1',
          LinkButton.component(
            {
              href: app.route('profile.jeepyta', { username: this.user.slug() }), // Use the user's slug
              name: 'uploads1',
              icon: 'fas fa-robot',
            },
            [
              this.user === app.session.user
                ? 'JeepyTA'
                : '',
              ' ',
            ]
          ),
          80
        );
      }
    }
  });
}
